import { createSlice } from '@reduxjs/toolkit'
import { useCookies } from 'react-cookie'


export const themeSlice = createSlice({
  name: 'theme',
  initialState: {
    landingPageWord:'',
    feedback:{
           message: '',
           color: ''
         },
    
  },
  reducers: {
    
    setLandingPageWordRedux: (state, action) => {
        const { landingPageWord } = action.payload
        state.landingPageWord = landingPageWord
      },
      setFeedbackRedux: (state, action) => {
        const { feedback } = action.payload
        state.feedback = feedback
      }
      
  },
})

export default themeSlice.reducer;

export const {
    setLandingPageWordRedux,
    setFeedbackRedux
  
} = themeSlice.actions

export const getLandingPageWordRedux = (state) => state.theme.landingPageWord
export const getFeedbackRedux = (state) => state.theme.feedback



